import { useApolloClient } from '@apollo/client';
import {
  JobOfferDocument,
  JobOfferFragment,
  JobOfferQuery,
  JobOfferQueryVariables,
} from '@vette/data-access';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const usePrefetchJobOffer = (
  onJobFetch: (jobOffer: JobOfferFragment) => void
) => {
  const [loading, setLoading] = useState(true);
  const apolloClient = useApolloClient();
  const router = useRouter();
  const jobOfferId = router.query?.args?.[0];

  useEffect(() => {
    (async () => {
      if (jobOfferId) {
        const result = await apolloClient.query<
          JobOfferQuery,
          JobOfferQueryVariables
        >({
          query: JobOfferDocument,
          variables: { jobOfferId },
        });

        if (result.data.jobOffer?.__typename === 'JobOffer') {
          onJobFetch(result.data.jobOffer);
        }

        setLoading(false);
      }
    })();
  }, [jobOfferId]);

  return { loading };
};
